import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';

import OrderFormWrapper from '../OrderFormWrapper/OrderFormWrapper';

const RouterWrapper = () => (
  <BrowserRouter>
    <Switch>
      <OrderFormWrapper />
    </Switch>
  </BrowserRouter>
);

RouterWrapper.propTypes = {
};
RouterWrapper.defaultProps = {};

export default RouterWrapper;
